const _temp0 = require("./chatgpt.svg");
const _temp1 = require("./sparkle.svg");
const _temp2 = require("./task-checkmark.svg");
const _temp3 = require("./task-circle.svg");
const _temp4 = require("./task-locked.svg");
const _temp5 = require("./task-paused.svg");
const _temp6 = require("./task-working.svg");
module.exports = {
  "chatgpt": _temp0,
  "sparkle": _temp1,
  "task-checkmark": _temp2,
  "task-circle": _temp3,
  "task-locked": _temp4,
  "task-paused": _temp5,
  "task-working": _temp6
}